<template>
  <v-container fluid>
    <BreadHeader :title="`New ${model.name.singular}`" />
    <BreadTabulatorForm action="add" :api="api" :model="model" />
  </v-container>
</template>

<script>
import Api from "@/objects/api";
import BreadcrumbTabulator from "@/objects/breadcrumbTabulator";
import Model from "@/objects/model";
import Service from "@/objects/service";
import { mapState } from "vuex";

export default {
  computed: mapState({
    services: (state) => state.service.data.services,
  }),
  data: () => ({
    api: new Api(),
    breadcrumbTabulator: new BreadcrumbTabulator(),
    model: new Model(),
    service: new Service(),
    apiStoreUrl: "",
  }),
  created() {
    this.model.getByKey(this.$route.params.modelKey);
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);
    this.breadcrumbTabulator.addForOperationBrowse({
      model: this.model,
      services: this.services,
    });

    if (this.model.apiUrls.apiStoreUrl != "") {
      this.apiStoreUrl = `${this.$service[this.service.key]}${
        this.model.apiUrls.apiStoreUrl
      }`;
    } else {
      this.apiStoreUrl = `${
        this.$service[this.service.key]
      }/v1/en/console/tabulator/model/${this.model.key}/add`;
    }

    this.api.setMethod(`POST`);
    this.api.setUrl(this.apiStoreUrl);
    this.api.setCallbackCompleted(() => {
      this.$router.push({
        name: "PageServiceModelBreadTabulatorBrowse",
        params: {
          serviceKey: this.model.serviceKey,
          modelKey: this.model.key,
        },
        query: {
          viewId: "all",
          tabIndex: 0,
        },
      });
      this.$store.dispatch("showMessage", {
        message: "Created successfully.",
        messageType: "success",
        timeout: 2000,
      });
    });
  },
};
</script>
